import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, Sparkles } from "lucide-react";
import { fetchProtocolsMenu } from "@/lib/api";

// Module cache so the bar doesn't refetch on every public-page mount.
let _menuCache = null;

/**
 * Dark-green Protocol Focus bar above the brand hero on every public page.
 * Shows the top six Protocol Focus titles (Airtable `Protocol_Focus` Sort order)
 * linking to their protocol pages, plus "See more" → the Protocol Builder.
 * Carries the dealer context (?d=<slug>) so visitors stay on that storefront.
 */
export default function TagsMenuBar({ activeSlug = "" }) {
  const [data, setData] = useState(_menuCache || { menu: [], total: 0 });
  const { pathname, search } = useLocation();
  const mPath = pathname.match(/\/d\/([^/?#]+)/);
  const dealer = mPath ? mPath[1] : new URLSearchParams(search).get("d") || "orevital";

  useEffect(() => {
    if (_menuCache) return;
    let alive = true;
    fetchProtocolsMenu()
      .then((d) => {
        _menuCache = d;
        if (alive) setData(d);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  const menu = data.menu || [];
  if (menu.length === 0) return null;

  return (
    <div className="w-full bg-[#1f5d36] text-white" data-testid="tags-menu-bar">
      <div className="max-w-6xl mx-auto px-2 sm:px-6">
        <div className="flex items-stretch gap-0 overflow-x-auto">
          {menu.map((t) => {
            const active = t.slug === activeSlug;
            return (
              <Link
                key={t.slug}
                to={`/protocols/${t.slug}?d=${dealer}`}
                data-testid={`protocol-menu-btn-${t.slug}`}
                className={`shrink-0 px-4 py-3 text-sm font-semibold whitespace-nowrap transition-colors ${
                  active ? "bg-[#2f7d4f] text-white" : "text-emerald-50 hover:bg-[#2a6f44]"
                }`}
              >
                {t.name}
              </Link>
            );
          })}
          <Link
            to={`/d/${dealer}?view=protocols`}
            data-testid="protocol-menu-seemore"
            className="shrink-0 h-full px-4 py-3 text-sm font-semibold whitespace-nowrap inline-flex items-center gap-1.5 bg-[#256a3e] hover:bg-[#2a6f44] transition-colors"
          >
            <Sparkles size={13} />
            See more{data.total > menu.length ? ` (${data.total})` : ""}
            <ChevronDown size={14} className="-rotate-90" />
          </Link>
        </div>
      </div>
    </div>
  );
}
